import React, { Component } from 'react';
import './App.css';
import 'semantic-ui-css/semantic.min.css';
import { Dropdown } from 'semantic-ui-react'

class App extends Component {
  render() {
    return (
      <div style={{width:"100%",marginTop:"200px"}}>
        <div style={{margin:"0 auto",
        width:"200px"}}>
            <div style={{
                width:"33%",textAlign:"center",
                float:"left",
            }}>1</div>
            <div style={{
                width:"33%",textAlign:"center",
                float:"left",
            }}>=</div>
            <div style={{
                width:"33%",textAlign:"center",
                float:"left",
            }}>0</div>
        </div>

          <div style={{margin:"0 auto",
              width:"200px"}}>
              <div style={{
                  width:"33%",textAlign:"center",
                  float:"left",
              }}>0</div>
              <div style={{
                  width:"33%",textAlign:"center",
                  float:"left",
              }}>=</div>
              <div style={{
                  width:"33%",textAlign:"center",
                  float:"left",
              }}>1</div>
          </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js